var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeLightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8177 2.69061C20.5822 1.80374 19.8882 1.10526 19.007 0.868225C17.4099 0.4375 11.0056 0.4375 11.0056 0.4375C11.0056 0.4375 4.60139 0.4375 3.00423 0.868225C2.12309 1.1053 1.42911 1.80374 1.19357 2.69061C0.765625 4.29812 0.765625 7.65205 0.765625 7.65205C0.765625 7.65205 0.765625 11.006 1.19357 12.6135C1.42911 13.5004 2.12309 14.1697 3.00423 14.4068C4.60139 14.8375 11.0056 14.8375 11.0056 14.8375C11.0056 14.8375 17.4099 14.8375 19.007 14.4068C19.8882 14.1697 20.5822 13.5004 20.8177 12.6135C21.2457 11.006 21.2457 7.65205 21.2457 7.65205C21.2457 7.65205 21.2457 4.29812 20.8177 2.69061ZM8.91108 10.6972V4.60694L14.2638 7.65212L8.91108 10.6972Z",
    fill: "#191916"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeLightIcon);
export default __webpack_public_path__ + "static/media/youtubeLightIcon.1ee534ef556bf61c1162937058323f10.svg";
export { ForwardRef as ReactComponent };